module.exports = __webpack_public_path__ + "img/jupiter.3b712aa3.png";